import Controller from './menu-category-manage.controller';
import template from './menu-category-manage.html';
import './menu-category-manage.less';

const Component = {
    template,
    bindings: {
        edit: '@?',
    },
    controller: [
        '$q',
        '$state',
        '$uibModal',
        'crConstants',
        'crConfig',
        'crEntityService',
        'crLocaleService',
        'crImageService',
        'crNavigationService',
        'crErrorLoggingService',
        'crAnalyticsService',
        Controller,
    ],
};

export default Component;
